// Hover-to-open desktop menus for Dawn (safe: no effect on mobile)
document.addEventListener('DOMContentLoaded', function () {
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  function wireHoverMenus() {
    // Dawn uses <details id="Details-HeaderMenu-..."> for top-level items
    const menuDetails = document.querySelectorAll('header details[id^="Details-HeaderMenu-"]');
    menuDetails.forEach((d) => {
      // Clean previous listeners (if hot-reloaded)
      d.onmouseenter = null;
      d.onmouseleave = null;

      d.addEventListener('mouseenter', () => {
        if (!desktopQuery.matches) return;
        // open on hover
        d.setAttribute('open', '');
      });

      d.addEventListener('mouseleave', () => {
  if (!desktopQuery.matches) return;

  const contentId = d.querySelector('summary')?.getAttribute('aria-controls');
  const content = contentId ? document.getElementById(contentId) : null;

  clearTimeout(d._closeTimer);

  d._closeTimer = setTimeout(() => {
    if (!d.matches(':hover') && !content?.matches(':hover')) {
      d.removeAttribute('open');
    }
  }, 300); // 300ms delay prevents accidental closing
});
    });
  }

  wireHoverMenus();
  // Re-apply if layout changes width
  window.addEventListener('resize', wireHoverMenus);
});
